export default __webpack_public_path__ + "static/img-8-ad96c30c097d44b706f56ab8e6b14c4e.png";